export const signin_styles = theme => ({
    logo: {
        width: 260,
        marginBottom: 74.6,
        [theme.breakpoints.down('xs')]: {
            display: "none"
        }
    },
    logoMobile: {
        width: 160,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    signInContainer: {
        margin: 'calc(50vh - 325px) auto',
        [theme.breakpoints.down('xs')]: {
            width: 280,
            margin: 'calc(50vh - 245px) auto',
        },
        [theme.breakpoints.up('sm')]: {
            width: 300,
            margin: 'calc(50vh - 325px) auto',
        }
    },
    navbar: {
        marginBottom: 50,
        width: 500,
        margin: 'auto'
    },
    inputFields: {
        display: 'flex',
        flexDirection: 'column'
    },
    button: {
        width: '100%',
        height: 48,
        marginBottom: 20
    },
    link: {
        textAlign: "left"
    },
    domain: { fontSize: "45px", fontWeight: "500" },
    adorment: {
        marginLeft: "-10px"
    },
    countryCode: {
        marginLeft: 10,
        lineHeight: "56px"
    },
    welcome: {
        fontSize: 24,
        color: "rgba(0,0,0,0.5)",
        marginBottom: 50,
        marginTop: 0
    },
    forgetPassword: {
        color: "rgba(0,0,0,0.87)",
        width: "100%",
        textAlign: "right",
        marginBottom: "100px",
        textDecoration: "none",
        display: "block",
        cursor: "pointer"
    },
    input: {
        width: "100%",
        marginBottom: 30
    },
    textField: {
        width: "100%"
    },
    dialogContent: {
        padding: 30
    }
});

export const legacyLogin_styles = theme => ({
    root: {
        padding: 30,
        width: 300
    },
    smMargin: {
        marginBottom: 20
    },
    mdMargin: {
        marginBottom: 60
    },
    lgMargin: {
        marginBottom: 120
    },
    button: {
        width: '100%',
        height: 48,
        marginBottom: 20
    },
    close: {
        textAlign: "right"
    }
})

export const recoverPwd_styles = theme => ({
    button: {
        marginTop: 90
    }
})